// extracted by mini-css-extract-plugin
module.exports = {"rack":"Rack_rack__2pUeB","tilePlace":"Rack_tilePlace__1GJPV","takeTile":"Rack_takeTile__2Xzpe"};